type DocxToolkit = typeof import('docx')
type ParagraphChild = import('docx').ParagraphChild

// 一次导出共用一个导航实例，正文和文末注释的书签编号不能重复。
export const createWordNavigation = (docx: DocxToolkit) => {
  let nextBookmarkId = 0

  class DocumentBookmark extends docx.Bookmark {
    readonly start: import('docx').BookmarkStart
    readonly end: import('docx').BookmarkEnd

    constructor(name: string, children: readonly ParagraphChild[]) {
      super({ id: name, children })
      // docx 9.5 的 Bookmark 每个实例都从 1 开始计数，改用文档级编号。
      const id = ++nextBookmarkId
      this.start = new docx.BookmarkStart(name, id)
      this.end = new docx.BookmarkEnd(id)
    }
  }

  const bookmark = (name: string, children: readonly ParagraphChild[] = []) =>
    new DocumentBookmark(name, children)

  const noteReference = (
    id: number,
    referenceBookmark?: string,
  ): ParagraphChild => {
    // 所有角标都是指向文末注释的上标链接，不生成页底原生脚注。
    const link = new docx.InternalHyperlink({
      anchor: `md_note_${id}`,
      children: [
        new docx.TextRun({
          text: String(id),
          superScript: true,
          color: '0563C1',
        }),
      ],
    })
    return referenceBookmark ? bookmark(referenceBookmark, [link]) : link
  }

  return { bookmark, noteReference }
}
